import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import { AdminProvider } from "./context/AdminContext";
import { AuthProvider } from "./context/AuthContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminLayout from "./components/AdminLayout";

import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import CategoriesPage from "./pages/CategoriesPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import SearchPage from "./pages/SearchPage";
import AuthPage from "./pages/AuthPage";
import MyAccountPage from "./pages/MyAccountPage";
import TrackOrderPage from "./pages/TrackOrderPage";

import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProductsPage from "./pages/admin/AdminProductsPage";
import AdminCategoriesPage from "./pages/admin/AdminCategoriesPage";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminCouponsPage from "./pages/admin/AdminCouponsPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";

const CustomerLayout = ({ children }) => (
  <>
    <Header />
    <main className="min-h-screen">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <AdminProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<CustomerLayout><HomePage /></CustomerLayout>} />
                <Route path="/categories" element={<CustomerLayout><CategoriesPage /></CustomerLayout>} />
                <Route path="/category/:slug" element={<CustomerLayout><CategoryPage /></CustomerLayout>} />
                <Route path="/product/:slug" element={<CustomerLayout><ProductPage /></CustomerLayout>} />
                <Route path="/cart" element={<CustomerLayout><CartPage /></CustomerLayout>} />
                <Route path="/checkout" element={<CustomerLayout><CheckoutPage /></CustomerLayout>} />
                <Route path="/order-success/:orderId" element={<CustomerLayout><OrderSuccessPage /></CustomerLayout>} />
                <Route path="/search" element={<CustomerLayout><SearchPage /></CustomerLayout>} />
                <Route path="/account" element={<AuthPage />} />
                <Route path="/my-account" element={<CustomerLayout><MyAccountPage /></CustomerLayout>} />
                <Route path="/track-order" element={<CustomerLayout><TrackOrderPage /></CustomerLayout>} />
                <Route path="/track-order/:orderId" element={<CustomerLayout><TrackOrderPage /></CustomerLayout>} />

                <Route path="/admin" element={<AdminLoginPage />} />
                <Route path="/admin/*" element={<AdminLayout />}>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProductsPage />} />
                  <Route path="categories" element={<AdminCategoriesPage />} />
                  <Route path="orders" element={<AdminOrdersPage />} />
                  <Route path="coupons" element={<AdminCouponsPage />} />
                  <Route path="settings" element={<AdminSettingsPage />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster
              position="top-right"
              richColors
              toastOptions={{ style: { fontFamily: 'Outfit, sans-serif' } }}
            />
          </div>
        </AdminProvider>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
